// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Banner_imageWrapper__lC1Sy"};